import type { ApiError } from '@/api/client'
import { currentLocale, i18n, translate } from '@/i18n'

/**
 * The operator-facing sentence for an {@link ApiError}.
 *
 * The API writes `detail` in English. On an English screen that text is shown as sent.
 * On an Arabic screen a *known* `code` (the stable contract every `ApiException`
 * carries) maps to a fixed Arabic sentence in `apierrors.codes.*`; an unknown code, or
 * no code at all, falls back to `error.message` so nothing is ever swallowed.
 *
 * Field-level validation messages are deliberately not touched: they stay as the
 * server sends them and bind straight onto the form inputs.
 */
export function apiErrorMessage(error: ApiError): string {
  if (currentLocale() === 'ar' && error.code) {
    const key = `apierrors.codes.${error.code}`
    if (i18n.global.te(key, 'ar')) return translate(key)
  }
  return error.message
}
